import { useEffect } from 'react';

import { Navigate, Outlet, useNavigate } from 'react-router-dom';

const ProtectedRoutes: React.FC = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('access_token');

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'access_token' && e.newValue === null) {
        navigate('/');
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [navigate]);

  return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoutes;
